import { Injectable } from '@angular/core';
import { MepStorage } from './abstract/mep-storage.abstract';
import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';

// interface LocalStorage {
//   [name: string]: any;
//   length: number;
//   clear(): void
//   getItem(key: string): string
//   key(index: number): string
//   removeItem(key: string): void
//   setItem(key: string, value: string): void
// }

@Injectable({
  providedIn: 'root',
})
export class StorageWebService implements MepStorage {
  public platformId = inject(PLATFORM_ID);

  public get(key: string): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    return localStorage.getItem(key);
  }

  public set(key: string, value: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.setItem(key, value);
  }

  public remove(key: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    localStorage.removeItem(key);
  }

  public removeItems(keys: any[]): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    keys.forEach((key) => {
      this.remove(key);
    });
  }

  public setItems(items: { [key: string]: any }): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    Object.keys(items).forEach((key) => {
      const value = items[key].toString();
      this.set(key, value);
    });
  }
}
